import { startCase } from 'es-toolkit';

import { assertExhaustiveSwitch, naturalSortByProperty } from '../../utilities';
import { BoundaryType, Lumber, LumberGrade, LumberSpecies } from './designService';

const lumberGradeNames: Record<LumberGrade, string> = {
  Number_3: 'No. 3',
  Number_2: 'No. 2',
  Number_1: 'No. 1',
  Dense_Select_Structural: 'DSS',
  Select_Structural: 'SS',
  Stud: 'Stud',
  Standard: 'Std',
  Utility: 'Utility',
  Construction: 'Cons',
  Dense_Number_1: 'No. 1D',
  Dense_Number_2: 'No. 2D',
  Dense_Number_3: 'No. 3D',
  Non_Dense_Number_1: 'No. 1ND',
  Non_Dense_Number_2: 'No. 2ND',
  Non_Dense_Number_3: 'No. 3ND',
  Number_1_And_Better: 'No. 1 & Btr',
  MEL_M_5: 'M 5',
  MEL_M_6: 'M 6',
  MEL_M_7: 'M 7',
  MEL_M_8: 'M 8',
  MEL_M_9: 'M 9',
  MEL_M_10: 'M 10',
  MEL_M_11: 'M 11',
  MEL_M_12: 'M 12',
  MEL_M_13: 'M 13',
  MEL_M_14: 'M 14',
  MEL_M_15: 'M 15',
  MEL_M_16: 'M 16',
  MEL_M_17: 'M 17',
  MEL_M_18: 'M 18',
  MEL_M_19: 'M 19',
  MEL_M_20: 'M 20',
  MEL_M_21: 'M 21',
  MEL_M_22: 'M 22',
  MEL_M_23: 'M 23',
  MEL_M_24: 'M 24',
  MEL_M_25: 'M 25',
  MEL_M_26: 'M 26',
  MEL_M_27: 'M 27',
  MEL_M_28: 'M 28',
  MEL_M_29: 'M 29',
  MEL_M_30: 'M 30',
  MEL_M_31: 'M 31',
  MEL_M_32: 'M 32',
  MEL_M_33: 'M 33',
  MEL_M_34: 'M 34',
  MEL_M_35: 'M 35',
  MEL_M_36: 'M 36',
  MEL_M_37: 'M 37',
  MEL_M_38: 'M 38',
  MEL_M_39: 'M 39',
  MEL_M_40: 'M 40',
  MEL_M_41: 'M 41',
  MEL_M_42: 'M 42',
  MSR_750f_1_4E: '750F 1.4E',
  MSR_850f_1_4E: '850F 1.4E',
  MSR_900f_1_0E: '900F 1.0E',
  MSR_975f_1_6E: '975F 1.6E',
  MSR_1050f_1_2E: '1050F 1.2E',
  MSR_1050f_1_6E: '1050F 1.6E',
  MSR_1200f_1_2E: '1200F 1.2E',
  MSR_1200f_1_3E: '1200F 1.3E',
  MSR_1200f_1_6E: '1200F 1.6E',
  MSR_1250f_1_4E: '1250F 1.4E',
  MSR_1250f_1_6E: '1250F 1.6E',
  MSR_1350f_1_3E: '1350F 1.3E',
  MSR_1350f_1_4E: '1350F 1.4E',
  MSR_1400f_1_2E: '1400F 1.2E',
  MSR_1450f_1_3E: '1450F 1.3E',
  MSR_1450f_1_5E: '1450F 1.5E',
  MSR_1500f_1_4E: '1500F 1.4E',
  MSR_1500f_1_5E: '1500F 1.5E',
  MSR_1500f_1_6E: '1500F 1.6E',
  MSR_1500f_1_7E: '1500F 1.7E',
  MSR_1600f_1_4E: '1600F 1.4E',
  MSR_1650f_1_3E: '1650F 1.3E',
  MSR_1650f_1_5E: '1650F 1.5E',
  MSR_1650f_1_6E: '1650F 1.6E',
  MSR_1650f_1_7E: '1650F 1.7E',
  MSR_1700f_1_6E: '1700F 1.6E',
  MSR_1800f_1_5E: '1800F 1.5E',
  MSR_1800f_1_6E: '1800F 1.6E',
  MSR_1800f_1_8E: '1800F 1.8E',
  MSR_1800f_2_0E: '1800F 2.0E',
  MSR_1850f_1_7E: '1850F 1.7E',
  MSR_1950f_1_5E: '1950F 1.5E',
  MSR_1950f_1_7E: '1950F 1.7E',
  MSR_2000f_1_6E: '2000F 1.6E',
  MSR_2100f_1_8E: '2100F 1.8E',
  MSR_2250f_1_7E: '2250F 1.7E',
  MSR_2250f_1_8E: '2250F 1.8E',
  MSR_2250f_1_9E: '2250F 1.9E',
  MSR_2400f_1_8E: '2400F 1.8E',
  MSR_2400f_2_0E: '2400F 2.0E',
  MSR_2500f_2_2E: '2500F 2.2E',
  MSR_2550f_1_8E: '2550F 1.8E',
  MSR_2550f_2_1E: '2550F 2.1E',
  MSR_2700f_2_0E: '2700F 2.0E',
  MSR_2700f_2_2E: '2700F 2.2E',
  MSR_2850f_1_8E: '2850F 1.8E',
  MSR_2850f_2_3E: '2850F 2.3E',
  MSR_3000f_2_4E: '3000F 2.4E',
  LFL_1_6E: '1.6E',
  LFL_1_7E: '1.7E',
  LFL_1_9E: '1.9E',
  LFL_2_1E: '2.1E',
  LVL_1_3E: '1.3E',
  LVL_1_5E: '1.5E',
  LVL_1_8E: '1.8E',
  LVL_2_0E: '2.0E',
  LVL_2_2E: '2.2E',
  LVL_2_3E: '2.3E',
  LSL_1730F_1_35E: '1730F 1.35E',
  LSL_2360F_1_55E: '2360F 1.55E',
  LSL_2500F_1_75E: '2500F 1.75E',
  Select_Structural_Open_Grain: 'SSOG',
  Select_And_Better: 'S&Btr',
  Non_Dense_Select_Structural: 'NDSS',
  Number_2_And_Better: 'No. 2 & Btr',
  Number_1_Open_Grain: 'No. 1 OG',
  Number_2_Open_Grain: 'No. 2 OG',
  Number_3_Open_Grain: 'No. 3 OG',
  Number_1_And_2: 'No. 1 & No. 2',
  Clear_Structural: 'CS',
  Economy: 'Econ',
  MasterPlank: 'MasterPlank',
  Kerto_S_2_0E: '2.0E',
  Unknown: 'Unknown',
  Combo: 'Combo',
};

export function formatLumberGrade(grade: LumberGrade, tangibleGrades: readonly LumberGrade[]) {
  if (grade === 'Combo' && tangibleGrades.length > 0) {
    return naturalSortByProperty(tangibleGrades, (grade) => grade)
      .map((grade) => lumberGradeNames[grade])
      .join('/');
  }
  if (grade in lumberGradeNames) {
    return lumberGradeNames[grade];
  }

  return grade;
}

const lumberSpeciesLongNames: Record<LumberSpecies, string> = {
  Southern_Pine: 'Southern Pine',
  Mixed_Southern_Pine: 'Mixed Southern Pine',
  Alaska_Cedar: 'Alaska Cedar',
  Alaska_Hemlock: 'Alaska Hemlock',
  Alaska_Spruce: 'Alaska Spruce',
  Alaska_Yellow_Cedar: 'Alaska Yellow Cedar',
  Aspen: 'Aspen',
  Bald_Cypress: 'Baldcypress',
  BC_OSB: 'Boise Cascade OSB',
  Beech_Birch_Hickory: 'Beech-Birch-Hickory',
  Coast_Sitka_Spruce: 'Coast Sitka Spruce',
  Cottonwood: 'Cottonwood',
  Douglas_Fir_Larch: 'Douglas Fir-Larch',
  Douglas_Fir_Larch_North: 'Douglas Fir-Larch (North)',
  Douglas_Fir_South: 'Douglas Fir-South',
  Eastern_Hemlock_Balsam_Fir: 'Eastern Hemlock-Balsam Fir',
  Eastern_Hemlock_Tamarack: 'Eastern Hemlock-Tamarack',
  Eastern_Softwoods: 'Eastern Softwoods',
  Eastern_White_Pine: 'Eastern White Pine',
  Engelmann_Spruce_Lodgepole_Pine: 'Engelmann Spruce-Lodgepole Pine',
  GPLam_LVL: 'GP Lam LVL',
  Hem_Fir: 'Hem-Fir',
  Hem_Fir_North: 'Hem-Fir (North)',
  KSLVL: 'Kerto LVL S-beam',
  LP_LVL: 'LP SolidStart LVL',
  LP_SolidStart_LSL: 'LP SolidStart LSL',
  MasterPlank_LVL: 'Master Plank LVL',
  Mixed_Maple: 'Mixed Maple',
  Mixed_Oak: 'Mixed Oak',
  Northern_Red_Oak: 'Northern Red Oak',
  Northern_Species: 'Northern Species',
  Northern_White_Cedar: 'Northern White Cedar',
  Norway_Spruce_North: 'Norway Spruce (North)',
  Parallam_PSL: 'Parallam PSL',
  Ponderosa_Pine: 'Ponderosa Pine',
  Red_Maple: 'Red Maple',
  Red_Oak: 'Red Oak',
  Redwood: 'Redwood',
  RigidLam_LVL: 'RigidLam LVL',
  Spruce_Pine_Fir: 'Spruce-Pine-Fir',
  Spruce_Pine_Fir_South: 'Spruce-Pine-Fir (South)',
  VersaLam_LVL: 'Versa-Lam LVL',
  Western_Cedars: 'Western Cedars',
  Western_Juniper: 'Western Juniper',
  Western_Woods: 'Western Woods',
  White_Oak: 'White Oak',
  White_Fir: 'White Fir',
  Yellow_Cedar: 'Yellow Cedar',
  Yellow_Poplar: 'Yellow Poplar',
  Unknown: 'Unknown',
  Combo: 'Combo',
};

export function formatLumberSpeciesLong(species: LumberSpecies, tangibleSpecies: readonly LumberSpecies[]) {
  if (species === 'Combo' && tangibleSpecies.length > 0) {
    return naturalSortByProperty(tangibleSpecies, (s) => s)
      .map((s) => lumberSpeciesLongNames[s])
      .join('/');
  }

  if (species in lumberSpeciesLongNames) {
    return lumberSpeciesLongNames[species];
  }

  return species;
}

const lumberSpeciesNames: Record<LumberSpecies, string> = {
  Southern_Pine: 'SP',
  Mixed_Southern_Pine: 'MixSP',
  Alaska_Cedar: 'AC',
  Alaska_Hemlock: 'AH',
  Alaska_Spruce: 'AS',
  Alaska_Yellow_Cedar: 'AYC',
  Aspen: 'Aspen',
  Bald_Cypress: 'BC',
  BC_OSB: 'BC OSB',
  Beech_Birch_Hickory: 'BBH',
  Coast_Sitka_Spruce: 'CSS',
  Cottonwood: 'CW',
  Douglas_Fir_Larch: 'DFL',
  Douglas_Fir_Larch_North: 'DFLN',
  Douglas_Fir_South: 'DFS',
  Eastern_Hemlock_Balsam_Fir: 'EHBF',
  Eastern_Hemlock_Tamarack: 'EHT',
  Eastern_Softwoods: 'ES',
  Eastern_White_Pine: 'EWP',
  Engelmann_Spruce_Lodgepole_Pine: 'ESLP',
  GPLam_LVL: 'GP Lam LVL',
  Hem_Fir: 'HF',
  Hem_Fir_North: 'HFN',
  KSLVL: 'KSLVL',
  LP_LVL: 'LP SolidStart LVL',
  LP_SolidStart_LSL: 'LP SolidStart LSL',
  MasterPlank_LVL: 'Master Plank LVL',
  Mixed_Maple: 'MM',
  Mixed_Oak: 'MO',
  Northern_Red_Oak: 'NRO',
  Northern_Species: 'NS',
  Northern_White_Cedar: 'NWC',
  Norway_Spruce_North: 'Norway Spruce (North)',
  Parallam_PSL: 'Parallam PSL',
  Ponderosa_Pine: 'PP',
  Red_Maple: 'RM',
  Red_Oak: 'RO',
  Redwood: 'RW',
  RigidLam_LVL: 'RigidLam LVL',
  Spruce_Pine_Fir: 'SPF',
  Spruce_Pine_Fir_South: 'SPFS',
  VersaLam_LVL: 'Versa-Lam LVL',
  Western_Cedars: 'WC',
  Western_Juniper: 'Western Juniper',
  Western_Woods: 'WW',
  White_Oak: 'WO',
  White_Fir: 'WF',
  Yellow_Cedar: 'YC',
  Yellow_Poplar: 'YP',
  Unknown: 'Unknown',
  Combo: 'Combo',
};

export function formatLumberSpecies(species: LumberSpecies, tangibleSpecies: readonly LumberSpecies[]) {
  if (species === 'Combo' && tangibleSpecies.length > 0) {
    return naturalSortByProperty(tangibleSpecies, (species) => species)
      .map((species) => lumberSpeciesNames[species])
      .join('/');
  }
  if (species in lumberSpeciesNames) {
    return lumberSpeciesNames[species];
  }

  return species;
}

export function getLumberDescription(lumber: Lumber) {
  return `${lumber.nominalThickness}x${lumber.nominalWidth} ${formatLumberSpecies(lumber.species, lumber.tangibleSpecies)} ${formatLumberGrade(
    lumber.grade,
    lumber.tangibleGrades,
  )}${lumber.treatmentType !== 'Untreated' ? ` ${startCase(lumber.treatmentType)}` : ''}`;
}

export function formatBoundaryType(boundaryType: BoundaryType) {
  switch (boundaryType) {
    case 'Unrestrained':
      return 'Unrestrained';
    case 'HorizontalRollerWithUpwardRelease':
      return 'Horizontal Roller with Upward Release';
    case 'HorizontalRoller':
      return 'Horizontal Roller';
    case 'VerticalRoller':
      return 'Vertical Roller';
    case 'Pinned':
      return 'Pinned';
    case 'PinnedWithUpwardRelease':
      return 'Pinned with Upward Release';
    case 'Fixed':
      return 'Fixed';
    case 'RotationFixed':
      return 'Rotation Fixed';
    case 'XandRFixed':
      return 'X and R Fixed';
    case 'YandRFixed':
      return 'Y and R Fixed';
    default:
      assertExhaustiveSwitch(boundaryType);
  }
}
